import { useSnackbar } from 'notistack';
import { useTranslation } from 'next-i18next';

// Shows a notification using notistack
// message passed should be a translation key
const useShowNotify = () => {
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation('');
    const call = (message) => {
        enqueueSnackbar(t(message), {
            variant: 'success',
            className: 'success-ui',
        });
    };
    return call;
};

export { useShowNotify as default };
//# sourceMappingURL=useShowNotify.js.map
